export default {
    forceLogout(reload=true){
        this.$store.dispatch('logout');

        if (reload){
            window.setTimeout(()=>{
                window.location.reload(true);
            }, 200);
        }
    },
    setDocumentTitle(title, force=false){
        if (!title){
            title = this.$route.name;
        }
        if (title === 'welcome'){
            document.title = 'DerasaTech';
        }else if (force){
            document.title = `${title} | DerasaTech`;
        }else{
            document.title = `${this.$route.meta.title} | DerasaTech`;
        }
    },
    asset(name, type=null, publicPath=true){
        let path = process.env.VUE_APP_ASSETS_PATH ? process.env.VUE_APP_ASSETS_PATH : (publicPath ? '/' : '@/assets');
        if (path.slice(-1) !== '/'){
            path += '/';
        }
        if (type){
            const imageTypes = ['img', 'imgs', 'image', 'images'];
            if (imageTypes.includes(type)){
                path += 'img/';
            }
        }
        return path + name;
    },
    showMsg(text, color = 'error', topBar=false, loading=false, timeout = 4000){
        this.$store.dispatch('addSnackMsg', {show: true, text: text, color: color, timeout: timeout, msgBar: topBar, progress: loading});
    },
    closeMsg(){
        this.snackMsg = {show: false, text: '', msgBar: true, closeMsg: true};  // closeMsg to prevent infinity loop
    },
    setLinearLoading(loading=true){
        let timeout = loading ? 20 : 300;
        window.setTimeout(()=>{
            this.$store.commit('SET_LINEAR_LOADING', loading);
        }, timeout)
    },
    numFormat(value){
        let formated = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return formated;
    },
    unitFormat(value, single, dual, plural){
        let unit = single;
        if (value == 1){
            return "1 " + single;
        }else if (value == 2){
            return dual;
        }else if (value <= 10){
            unit = plural;
        }
        return `${this.numFormat(value)} ${unit}`;
    },
    moneyFormat(value, currency=false){
        const money = this.numFormat( parseFloat(value).toFixed(2) );
        return currency ? money + ' جنيه' : money;
    },
    scrollToTop(smooth=false){
        let scrollQuery = this.$route.query && this.$route.query.scrollTo ? this.$route.query.scrollTo : null;
        window.setTimeout(()=>{
            
            let el = document.documentElement;
            if (scrollQuery){
                let scrollTo = this.$refs[this.$route.query.scrollTo];
                this.scrollToElement(scrollTo);
            }else{
                if (el.scrollTop > 50){
                    if (smooth){
                        this.$vuetify.goTo(0, {container: el});
                    }else{
                        el.scrollTop = 0;
                    }
                }
            }
        }, scrollQuery ? 400 : 250);
    },
    scrollToElement(scrollTo){
        let el = document.documentElement;
        if (scrollTo){
            this.$vuetify.goTo(scrollTo, {container: el});
        }
    },
    goBack(){
        this.$router.go(-1);
    },

    dateTimeFormat(time, isTimestamp=false){
        var d;
        if (isTimestamp){
            d = new Date(time); // it's a timestamp
        }else{
            // Split timestamp into [ Y, M, D, h, m, s ]
            var t = time.split(/[- :]/); // splitting timestamp into array t[], so t[0] is the year .. etc
            // Apply each element to the Date function
            d = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5])); // t[1]-1  -> months starts from 0
            d.setTime(d.getTime());
        }

        let month = d.getMonth()+1;
        let day = d.getDate();

        if (month < 10){
            month = "0" + month;
        }
        if (day < 10){
            day = "0" + day;
        }

        let hours = d.getHours();
        let minutes = d.getMinutes();
        let ampm = ' AM';
        if (hours >= 12){
            ampm = ' PM';
        }
        if (hours > 12){
            hours -= 12;
        }

        if (minutes < 10){
            minutes = "0" + minutes;
        }
        if (hours < 10){
            hours = "0" + hours;
        }
        return `${d.getFullYear()}-${month}-${day} - ${hours}:${minutes}${ampm}`;
    },
    stringLimit(string, limit){
        if (!string){
            return string;
        }else{
            return string.length > limit ? string.slice(0, limit) + '...' : string;
        }
    }
}